import React from 'react';
import './labeling-page.css';

const generateId =(str)=>{
    return str.replace(/ /g,"_");
}
const renderLabelItem = (label, parent_index, index)=>{
    if(label.type==='image'){
        return (<img src={`${process.env.PUBLIC_URL}/images/`+label.image} id={'img_'+generateId(label.value)} alt={label.value} style={label.style}/>);
    }else{
        return <div id={'text_label_'+parent_index+'_'+index} dangerouslySetInnerHTML={{ __html: label.value }} />;
    }
};

/**
 * Component for displaying individual label data
 */
export const LabelItem= (props) => {
    return (
        <div className="label-item">
            {props.label.map((label, index) => (
                    <div className="item" key={'item'+index} style={label.style}>
                        { renderLabelItem(label, props.index, index) }
                    </div>
            ))}
        </div>
    );
}
